import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import Slider from "react-slick";
import { BaseUrl } from "../../helper/BaseUrl";
import axios from "axios";

const truncateText = (htmlString, maxLength) => {
    if (!htmlString || typeof htmlString !== "string") return "";
    const plainText = htmlString.replace(/<\/?[^>]+(>|$)/g, "");
    return plainText.length > maxLength ? plainText.substring(0, maxLength) + "..." : plainText;
};

export default function HomeDiary({ btnChange = "", initialData }) {
    const sliderRef = useRef(null);
    const facebookWidgetRef = useRef(null);
    const [allData, setAllData] = useState(initialData || []);
    const [loadFacebookWidget, setLoadFacebookWidget] = useState(false);

    const convertDate = (dateString) => {
        const date = new Date(dateString);
        const months = ["Jan", "Feb", "March", "April", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = months[date.getMonth()];
        const day = date.getDate();
        const year = date.getFullYear();
        return `${month} ${day}, ${year}`;
    };

    const dataFetcher = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/api/blogs`);
            setAllData(response.data.blogs);
        } catch (error) {
            console.error("Data fetch error:", error);
            throw error;
        }
    };

    useEffect(() => {
        dataFetcher();
    }, [])

    useEffect(() => {
        if (!facebookWidgetRef.current) return;

        const loadWidget = () => setLoadFacebookWidget(true);

        if ("IntersectionObserver" in window) {
            const observer = new IntersectionObserver(
                (entries) => {
                    if (entries.some((entry) => entry.isIntersecting)) {
                        loadWidget();
                        observer.disconnect();
                    }
                },
                { rootMargin: "600px 0px" }
            );

            observer.observe(facebookWidgetRef.current);
            return () => observer.disconnect();
        }

        const timer = setTimeout(loadWidget, 2500);
        return () => clearTimeout(timer);
    }, [])

    if (!allData) {
        return null;
    }

    const settings = {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 1100,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        pauseOnHover: false,
        cssEase: "ease",
        draggable: false,
        swipe: false,
        responsive: [
            {
                breakpoint: 991,
                settings: { slidesToShow: 2, draggable: true, swipe: true, autoplay: true, },
            },
            {
                breakpoint: 767,
                settings: { slidesToShow: 1, draggable: true, swipe: true, autoplay: true, },
            },
            {
                breakpoint: 599,
                settings: { slidesToShow: 1, draggable: true, swipe: true, autoplay: true, },
            },
        ],
    };

    const CustomArrows = () => (
        <>
            <div className="default-arrowleft default-mobilearrow" onClick={() => sliderRef.current.slickPrev()}>
                <Icons name="arrowLeft" />
            </div>
            <div className="default-arrowright default-mobilearrow" onClick={() => sliderRef.current.slickNext()}>
                <Icons name="arrowRight" />
            </div>
        </>
    );

    return (
        <>
            <div className="home-diary">
                <div className="container">
                    <div className="row">

                        <div className="col-lg-12">
                            <h4 className="heading center-heading">LPS Diaries</h4>
                        </div>

                        <div className="col-lg-12">
                            <Slider {...settings} ref={sliderRef} className="homeblog-slider"> 
                                <div>
                                    <div className="facebook-widget" ref={facebookWidgetRef}>
                                        {loadFacebookWidget ? (
                                            <iframe title="Facebook Page Timeline Widget"
                                                src="https://www.facebook.com/plugins/page.php?href=https://www.facebook.com/lpscpsingh/&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true"
                                                width="100%"
                                                height="100%"
                                                style={{ border: "none", overflow: "hidden" }}
                                                scrolling="no"
                                                frameBorder="0"
                                                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                                                allowFullScreen={true}>
                                            </iframe>
                                        ) : (
                                            <div aria-hidden="true" style={{ minHeight: "400px" }} />
                                        )}
                                    </div>      
                                </div>
                 

                                {allData && allData.slice(0, 2).map((data, index) => (
                                    <div key={index}>
                                        <Link to={`/blog/${data.slug}`}>
                                            <div className="redshow">
                                                <div className="diary-card">
                                                    <div className="diary-blog">
                                                        <img src={`${BaseUrl}${data.image}`} className="img-responsive" alt="diary" loading="lazy" />
                                                        <div>
                                                            <span>{convertDate(data.date)}</span>
                                                            <p>{truncateText(data.name, 38)}</p>
                                                        </div>
                                                    </div>

                                                    <div className="diary-notes flip-sideview">
                                                        <h4 className="heading">{convertDate(data.date)}</h4>
                                                        <p>{truncateText(data.description, 150)}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                ))}
                            </Slider>
                            <CustomArrows />
                        </div>

                        <div className="col-lg-12 text-center mt-4">
                            <Link to={"/blog"} className={`default-btn ${btnChange}`}>
                                <div><span>View All</span><span>View All</span></div>
                            </Link>
                        </div>
                   
                        <img src="/image/diary-back.webp" className="diary-shape" alt="shape" loading="lazy" />
                    </div>
                </div>
            </div>
        </>
    )
}
